import { Corporate } from 'entities-next/corporate'
import { useFormikContext } from 'formik'
import React, { useState } from 'react'
import { FormActionBar, FormContainer } from 'scenes/Dashboard/components-next/Forms'
import CreateDemoSpaceForCorporateModalComponent from 'scenes/Dashboard/scenes/CorporateManager/scenes/CorporateDetailsView/components/CorporateDataForm/modals/CreateDemoSpaceForCorporateModal.component'
import { FormProps } from 'utils-next/forms'

import { Button, Portal } from '@mui/material'

import { useCorporateDataFormStyles } from '../../../../../UsersManager/scenes/UserDetailsView/components/UserDataForm/CorporateDataForm.styles'
import { CorporateCommonData } from './CorporateCommonData.component'
import { CorporateFormData } from './CorporateDataForm.data'

export type UserDataFormContentProps = FormProps<CorporateFormData> & {
  actionBarRef: React.MutableRefObject<any>
}

export function CorporateDataFormContent({ isSubmitting, handleSubmit, actionBarRef }: UserDataFormContentProps) {
  const { classes } = useCorporateDataFormStyles()
  const { values } = useFormikContext<Corporate>()
  const [isOpenedCreateDemoSpaceForCorporateModal, setIsOpenCreateDemoSpaceForCorporateModal] = useState(false)
  return (
    <FormContainer disabled={isSubmitting}>
      <CorporateCommonData className={classes.formSection} />

      <Portal container={actionBarRef?.current}>
        <FormActionBar onSubmit={handleSubmit}>
          {isOpenedCreateDemoSpaceForCorporateModal && (
            <CreateDemoSpaceForCorporateModalComponent
              corporateId={values.id}
              onClose={() => setIsOpenCreateDemoSpaceForCorporateModal(false)}
            />
          )}
          <Button variant="contained" color="info" onClick={() => setIsOpenCreateDemoSpaceForCorporateModal(true)}>
            Add Demo Space
          </Button>
        </FormActionBar>
      </Portal>
    </FormContainer>
  )
}
